/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import SafeWaitHandle from './SafeWaitHandle';

/**
 * The WaitHandle model module.
 * @module model/WaitHandle
 * @version V1
 */
class WaitHandle {
    /**
     * Constructs a new <code>WaitHandle</code>.
     * @alias module:model/WaitHandle
     */
    constructor() { 
        
        WaitHandle.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>WaitHandle</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/WaitHandle} obj Optional instance to populate.
     * @return {module:model/WaitHandle} The populated <code>WaitHandle</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new WaitHandle();

            if (data.hasOwnProperty('handle')) {
                obj['handle'] = ApiClient.convertToType(data['handle'], Object);
            }
            if (data.hasOwnProperty('safeWaitHandle')) {
                obj['safeWaitHandle'] = SafeWaitHandle.constructFromObject(data['safeWaitHandle']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>WaitHandle</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>WaitHandle</code>.
     */
    static validateJSON(data) {
        // validate the optional field `safeWaitHandle`
        if (data['safeWaitHandle']) { // data not null
          SafeWaitHandle.validateJSON(data['safeWaitHandle']);
        }

        return true;
    }


}



/**
 * @member {Object} handle
 */
WaitHandle.prototype['handle'] = undefined;

/**
 * @member {module:model/SafeWaitHandle} safeWaitHandle
 */
WaitHandle.prototype['safeWaitHandle'] = undefined;






export default WaitHandle;

